import * as TypeUtils from './TypeUtils'

export function get(key,force=false) {
  if (TypeUtils.isNonEmptyString(key)) {
    const value = localStorage.getItem(key)
    if (TypeUtils.isNonEmptyString(value)) {
      try {
        const o = JSON.parse(value)
        if (TypeUtils.isObject(o)) {
          const type = o.type
          const value = o.value
          if (force) {
            return value
          }
          if (TypeUtils.isNonEmptyString(type)) {
            if (type==='object') {
              if (TypeUtils.isObject(value)) {
                return value
              }
            } else if (type==='number') {
              if (TypeUtils.isNumber(value)) {
                return value
              }
            } else if (type==='string') {
              if (TypeUtils.isString(value)) {
                return value
              }
            }
          }
        }
      } catch(e) {
      }
    }
  }
  return undefined
}

export function set(key, value) {
  if (TypeUtils.isNonEmptyString(key)) {
    if (value===undefined) {
      remove(key)
    } else {
      const type = typeof(value)
      if (['object','number','string'].includes(type)) {
        localStorage.setItem(key, JSON.stringify({
          type: type,
          value: value,
        }))
      }
    }
  }
}

export function remove(key) {
  if (TypeUtils.isNonEmptyString(key)) {
    localStorage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/util/CacheUtils.js